<template>
  <div class="wrap">
    <userHead></userHead>
    <div class="content display_flex EC_width">
      <div class="contentLeftMenu">
        <ul class="newMenu">
          <li :class="{ newMenuActive: activeMenu == index }"
              v-for="(item, index) in menuListNew"
              @click="tagMenu(item.url, index)"
              :key="index">
            <span class="newMenuItem">
              <img v-for="(itemimg, indeximg) in item.imageUrl"
                   :key="indeximg + '1'"
                   :src="itemimg"
                   :class="[indeximg == 0 ? 'normalImg' : 'activeImg']" />
              {{ item.name }}
              <a style="margin-left:15%"
                 v-if="item.children != null && item.children.length > 0"><img v-if="activeMenu != index"
                     src="/image/geren/xiangshang.png" /><img v-else-if="activeMenu == index"
                     src="/image/geren/xiangxia.png" /></a>
            </span>
            <template v-if="item.children.length > 0">
              <ul class="DropMenu"
                  @click.stop>
                <li :class="{ DropMenuActive: activeDropMenu == indexx }"
                    class="DropMenuItem"
                    v-for="(itemx, indexx) in item.children"
                    @click="tagDropMenu(itemx.url, indexx, itemx)"
                    :key="indexx">
                  <span :class="[itemx.children != null && itemx.children.length ? 'inlinestart20' : '']"> {{ itemx.name }}</span>
                  <a v-if="itemx.children != null && itemx.children.length > 0">
                    <img v-if="activeDropMenu != indexx"
                         src="/image/geren/chixiangshang.png"
                         style="vertical-align:top; margin-top: 12px;" />
                    <img v-else-if="activeDropMenu == indexx"
                         src="/image/geren/chixiangxia.png"
                         style="vertical-align:top; margin-top: 12px;" />
                  </a>
                  <template v-if="itemx.children != null && itemx.children.length > 0 &&activeDropMenu == indexx">
                    <ul :class="[activeDropMenuTowdispaly == true ? 'DropMenuActiveTow' : 'DropMenuTow']"
                        class="DropMenu "
                        style="padding-inline-start: 20px;"
                        @click.stop>
                      <li :class="{ DropMenuActive: activeDropMenuTow == indexxx }"
                          class="DropMenuItem"
                          v-for="(itemxx, indexxx) in itemx.children"
                          :key="indexxx"
                          @click="tagDropMenuTow(itemxx.url, indexxx)">
                        <span v-if="itemxx.isdisplay">{{ itemxx.name }}</span>
                        <span v-else-if="!itemxx.isdisplay">{{ itemxx.name }}</span>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </div>
      <div class="contentRightMenu">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import userHead from '../user/user_head';
export default {
  name: 'index',
  data () {
    return {
      tagIndex: 'userInfor',
      menuListNew: [],
      endjson: {
        url: 'userInfor',
        name: '个人中心',
        imageUrl: ['/image/geren/menuIcon1.png', '/image/geren/menuActive1.png'],
        children: []
      },
      startjson: {
        url: '',
        name: '店铺中心',
        imageUrl: ['/image/geren/menuIcon7.png', '/image/geren/menuActive7.png'],
        children: []
      },
      menuList: [],
      activeMenu: 0,
      activeDropMenu: 0,
      activeDropMenuTow: -1,
      activeDropMenuTowdispaly: false
    };
  },
  created () {
    if (!localStorage.getItem('storeId')) {
      this.$message.error('店铺ID获取失败');
      this.$router.push({
        name: 'userStoreCenter'
      })
    }
    this.GetMyMenuList();
  },
  components: {
    userHead
  },
  watch: {
    $route (to) {
      for (let i = 0; i < this.menuListNew[0].children.length; i++) {
        if (this.menuListNew[0].children[i].children.length > 0) {
          for (let j = 0; j < this.menuListNew[0].children[i].children.length; j++) {
            if (this.menuListNew[0].children[i].children[j].url == to.name) {
              this.activeDropMenu = i
              this.activeDropMenuTowdispaly = true;
              this.activeDropMenuTow = j;
            }
          }
        } else {
          if (this.menuListNew[0].children[i].url == to.name) this.activeDropMenu = i
        }
      }
    }
  },
  methods: {
    tagContent (index) {
      this.tagIndex = index;
      this.$router.push({ name: this.tagIndex });
    },
    tagMenu (pathName, index) {
      this.activeMenu = index;
      this.activeDropMenuTow = -1;
      this.activeDropMenu = -1;
      this.activeDropMenuTowdispaly = false;
      this.$router.push({ name: pathName });
    },
    tagDropMenu (pathName, index, itemx) {
      if (itemx.children.length != 0) {
        this.activeDropMenuTowdispaly = true;
        this.activeDropMenuTow = -1;
        this.activeDropMenu = '';
      } else {
        this.activeDropMenuTowdispaly = false;
      }
      this.activeDropMenu = index;
      this.$router.push({ name: pathName });
    },
    tagDropMenuTow (pathName, index) {
      this.activeDropMenuTow = index;
      this.$router.push({ name: pathName });
    },
    GetMyMenuList () {
      let _this = this
      this.httphelper.post('/api/EnterpriseApi/GetCollegMenuList', {
        userId: Number(JSON.parse(localStorage.getItem('ResData')).id),
        to_user_id: Number(localStorage.getItem('storeId')),
        to_user_type: Number(localStorage.getItem('storeType'))
      })
        .then(res => {
          if (res.data.code == 200) {
            _this.menuListNew.push(_this.startjson)
            _this.menuListNew[0].children = res.data.data
            _this.menuListNew.push(_this.endjson)
            for (let i = 0; i < this.menuListNew[0].children.length; i++) {
              if (this.menuListNew[0].children[i].children.length > 0) {
                for (let j = 0; j < this.menuListNew[0].children[i].children.length; j++) {
                  if (this.menuListNew[0].children[i].children[j].url == this.$route.name) {
                    this.activeDropMenu = i
                    this.activeDropMenuTowdispaly = true;
                    this.activeDropMenuTow = j;
                  }
                }
              } else {
                if (this.menuListNew[0].children[i].url == this.$route.name) this.activeDropMenu = i
              }
            }
          }
        });
    }
  },

};
</script>

<style scoped>
.activeImg {
    display: none;
}
.pubL_menu_active .activeImg {
    display: inline-block;
}
.pubL_menu_active .normalImg {
    display: none;
}
.wrap {
    min-height: 730px;
    display: flex;
    flex-direction: column;
}
/* 左边菜单部分 */
.pubL_menu {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 184px;
}

.pubL_menu li {
    position: relative;
}

.pubL_menu li a {
    display: inline-block;
    height: 46px;
    width: 138px;
    text-align: center;
    line-height: 46px;
}

.pubL_menu li a img {
    float: left;
    margin-left: 30px;
    margin-top: 15px;
}

.arrtig {
    position: absolute;
    width: 0;
    height: 0;
    border: solid 23px;
    border-color: transparent transparent transparent #0b8686;
    right: 0;
    top: 0;
    display: none;
}

.pubL_menu_active a {
    background: #0b8686;
    color: #fff;
    border-radius: 6px 0 0 6px;
}

.pubL_menu_active .arrtig {
    display: block;
}
.content {
    flex: 1;
    padding-top: 40px;
    padding-bottom: 40px;
}
.contentLeftMenu {
    padding-top: 40px;
}
.contentRightMenu {
    margin-left: 67px;
    flex: 1;
}
/*新菜单*/
.newMenu {
    width: 200px;
    list-style: none;
    margin: 0;
    padding: 0;
}
.newMenuItem {
    display: inline-block;
    width: 100%;
    height: 42px;
    line-height: 42px;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.newMenuItem img {
    vertical-align: -3px;
    margin-right: 10px;
    width: 20px;
    height: 18px;
}
.newMenuActive .DropMenu {
    max-height: 600px;
}

.newMenuActive .activeImg {
    display: inline-block;
}
.newMenuActive .normalImg {
    display: none;
}

.newMenuActive .newMenuItem {
    background: #0b8586;
    border-radius: 5px;
    color: #fff;
}

.DropMenu {
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s;
}
.DropMenuItem {
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    cursor: pointer;
}
.DropMenuActive {
    color: #0b8586;
}
.DropMenuTow {
    display: none;
}
.DropMenuActiveTow {
    display: block;
}

.inlinestart20 {
    padding-inline-start: 20px;
}
</style>
